import request from "@/utils/request";

export function getVipCombos() {
  return request({
    url: "/vip/list",
    method: "get"
  });
}

export function getPopularizeRecord() {
  return request({
    url: "/vip/extension/list",
    method: "get"
  });
}

export function getSharedInfo() {
  return request({
    url: "/vip/extension/info",
    method: "get"
  });
}

export function gainFreeVipDay() {
  return request({
    url: "/vip/receive",
    method: "get"
  });
}

export function topUpVip(customerId, vip) {
  return request({
    url: "/orders/sureVip",
    method: "post",
    params: {
      customerId,
      vip
    }
  });
}
